module.exports = __webpack_public_path__ + "static/rochester.22073079.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/highered_logos/rochester.png
// module id = 2197
// module chunks = 61762850755587